
import { create } from 'apisauce';
import axios from 'axios';
import store from '@/store'

const backendHost = () => {
  if (location.hostname.includes('localhost') || location.hostname.includes('develop')) {
    return 'https://api-fanzone.develop.kicket.com/'
  } 
  return 'https://api-fanzone.kicket.com/'
}

const config = {
  MEDIA_URL: 'media/fanzones/flatpages/images',
  BACKEND_HOST: backendHost(),
};

export const baseURL = `${config.BACKEND_HOST}`;
export const mediaURL = `${config.MEDIA_URL}`;
export const mediaROOT = `${baseURL}/${mediaURL}/`

const { CancelToken } = axios;
const RequestCancellationArr = [];

const api = create({
  baseURL,
  crossDomain: true,
  headers: {
    'content-type': 'application/json',
  },
});

const saveToken = ({ token }) => {
  localStorage.setItem('token', token);
};


export const resetToken = () => {
  localStorage.removeItem('token');
};

const refresh = async () => {
  resetToken();
  alert('Bad Security Code!');
  return false;
};

const returnResponse = async (method, url, data, responseType) => api[method](url, data, {
  responseType,
  headers: {
    Authorization: `Bearer ${store.state.user.accessToken}`,
  },
});

export const login = (data) => {
  saveToken({ token: data.token });
  return true;
};

export const cancelRequests = () => {
  RequestCancellationArr.forEach((e) => {
    e.cancel();
  });

  RequestCancellationArr.length = 0;
};

export const tokenRefresh = async () => {
  const response = await sendRequest(
    'post',
    'api/token/refresh/',
    {
      refresh: store.state.user.refreshToken
    }
  )
  const { data: { meta, data } } = response
  if (meta && meta.status === 'ok') {
    console.log('token refreshed')
    const { access: accessToken, refresh: refreshToken } = data
    store.dispatch('refreshToken', { accessToken, refreshToken })
  }
}

export const sendRequest = async (method, url, data, responseType = 'json') => {
  const response = await returnResponse(method, url, data, responseType)
  return response
};

export default {};
